module.exports = __webpack_public_path__ + "img/logininterno.50155809.png";